import type { CompletedOrdersResponse } from '@/checkout/helpers/completing'
import { stripePayment } from '@/checkout/helpers/payloads'
import { checkout } from '@/checkout/helpers/processing'
import TixStripeError from '@/checkout/stripe/TixStripeError'
import { logInTrackJS } from '@/errors/helpers'
import type { IdentityFormData } from '@/helpers/IdentityHelpers'
import type { ConfirmAfterpayClearpayPaymentData, Stripe } from '@stripe/stripe-js'

export function handleAfterpayRedirectResponse(
  stripe: Stripe,
  cartId: string,
  clientSecret: string,
  options,
): Promise<CompletedOrdersResponse> {
  return stripe.retrievePaymentIntent(clientSecret).then((response) => {
    if (response.error) {
      throw new TixStripeError(response.error)
    } else {
      const paymentIntent = response.paymentIntent
      if (paymentIntent.status === 'requires_capture') {
        // TODO Test this for other currencies
        // PaymentIntent amount is in cents/pence.
        const payload = stripePayment(paymentIntent.amount / 100, paymentIntent.id, false)
        return checkout(cartId, payload, options)
      } else if (paymentIntent!.last_payment_error) {
        throw new TixStripeError(paymentIntent!.last_payment_error)
      } else {
        // Not sure if it is possible to end up here.
        logInTrackJS('Unexpected Afterpay Error', paymentIntent)
        throw new Error(paymentIntent!.status)
      }
    }
  })
}

export function afterpayData(
  cartId: string,
  identityFormData: IdentityFormData,
  purchaserId?: string,
): ConfirmAfterpayClearpayPaymentData {
  const details = {
    name: `${identityFormData.first_name} ${identityFormData.last_name}`,
    address: {
      line1: identityFormData.address as string,
      city: identityFormData.city as string,
      state: identityFormData.state as string,
      country: identityFormData.country as string,
      postal_code: identityFormData.zip_code as string,
    },
  }
  return {
    payment_method: {
      billing_details: {
        email: identityFormData.email as string,
        ...details,
      },
    },
    shipping: details,
    return_url: `${location.origin}/checkout?cartId=${cartId}&purchaser=${purchaserId}`,
  }
}
